import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const CodigoVerificacionModal = ({ email, onSuccess, onClose }) => {
  const [codigo, setCodigo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { setIsAuthenticated, setUser } = useAuth();

  const handleVerificar = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post('/api/verificar-codigo', {
        email,
        codigo
      });

      if (response.data.mensaje === 'VERIFIED_SUCCESS' || response.data.error === 'ALREADY_VERIFIED') {
        const token = response.data.token;
        const user = response.data.user;

        if (token && user) {
          localStorage.setItem('token', token);
          setIsAuthenticated(true);
          setUser(user);
        }

        setSuccess(true);
        setTimeout(() => {
          onSuccess();
          window.location.href = '/dashboard';
        }, 1000);
      }
    } catch (err) {
      if (err.response?.status === 410) {
        setError('El código ha expirado. Solicita uno nuevo.');
      } else if (err.response?.status === 401) {
        setError('Código incorrecto. Intenta nuevamente.');
      } else if (err.response?.data?.error === 'ALREADY_VERIFIED') {
        setSuccess(true);
        setTimeout(() => {
          onSuccess();
          window.location.href = '/dashboard';
        }, 1000);
      } else {
        setError('Error al verificar. Intenta más tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
        <h2 className="text-xl font-semibold mb-4">Verifica tu cuenta</h2>
        <p className="text-sm text-gray-500 mb-4">Ingresa el código de 6 dígitos que enviamos a <strong>{email}</strong>.</p>

        <input
          type="text"
          placeholder="Código de verificación"
          maxLength={6}
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
          className="w-full px-4 py-2 border rounded"
        />

        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        {success && <p className="text-green-600 text-sm mt-2">¡Código verificado!</p>}

        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            className="text-gray-600 px-4 py-2 rounded hover:bg-gray-100"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            type="button"
            disabled={loading || codigo.length !== 6}
            onClick={handleVerificar}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
          >
            {loading ? 'Verificando...' : 'Verificar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CodigoVerificacionModal;
